// extracted by mini-css-extract-plugin
module.exports = {"example-content":"nwea-ds-v1-template-example-content","example-child":"nwea-ds-v1-template-example-child"};